import React from 'react';

import {
    Card,
    makeStyles
} from '@material-ui/core';

import { Producto } from './Producto';
import { relationSBICategory } from '../constants/SBIConfig';
import { relationSPUCategory } from '../constants/SPUConfig';
import { ProductosAgrupados } from './ProductosAgrupados';
import { api, esGestiona, IconAbajo, IconArriba, PortalContext } from '@portal/arq-portal-core';

import useSWR from "swr";

const useStyles = makeStyles(theme => ({
    lista: {
        columnCount: 3,
        columnGap: '2rem',
        marginTop: '.5rem',
        '@media screen and (max-width: 959px)': {
            columnCount: 1
        }
    },
    producto: {
        backgroundColor: "#FFFFFF",
        padding: "15px",
        margin: "10px 0px 10px 0px"
    },
    cardContainer: {
        marginBottom: '10px',
        'break-inside': 'avoid-column',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        '& .MuiCardContent-root:last-child': {
          paddingBottom: '.5rem',
          marginBottom: '15px',
        },
        '& .MuiSvgIcon-root': {
          fontSize: '14px',
          color: theme.palette.secondary.main,
          '&:focus, &:active': {
            color: '#DC0028 !important',
          },
        },
    },
    itemMenuReducidoyCompletoContainer: {
        backgroundColor: '#f4f4f4',
        display: 'flex',
        justifyContent: 'center',
        alignItems:'center',
    },
    itemMenuReducidoyCompleto: {
        color: '#dc0028 !important',
        fontSize: '12px !important',
        fontWeight: 'bold',
        fontFamily: 'Catalana-sans, Arial, sans-serif',
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
            color: '#dc0028 !important',
            '& .MuiSvgIcon-root': {
                color: '#dc0028 !important',
            }
        }
    },
    itemIcon: {
        padding: '0 0 0 0.5rem',
        fontSize: '12px !important',
        color: '#dc0028 !important',
    }
}));

interface ListaProductosProps {
    productos?: any[];
    cia: string | null;
    favs: any;
};


const ciaShowGroupedProducts = [ "SBI", "SPU" ];



var getProductosReducido = function (menuOption: any, favs: any, fatherExistsFavDescendent:any) {
    // debugger;
    var options =
      menuOption.enlaces != null && !esGestiona()
        ? menuOption.enlaces.filter((x: any) => !x.oculto)
        : null;
    const esFav = menuOption.id && favs && favs.find((x: any) => x.Url != null && x.Url.toLowerCase() == menuOption.id.toLowerCase()) != null;
    
    if (options != null && options.length > 0) {
      let existsFavDescendent:boolean = false;
      var components = options.map(
        (enlace: any) => !enlace.oculto && getProductosReducido(enlace, favs, (childFav:any)=>{{ existsFavDescendent = existsFavDescendent || childFav}})
      )?.filter((e:any) => e != null);

      if(existsFavDescendent && fatherExistsFavDescendent){ fatherExistsFavDescendent(existsFavDescendent)}
      let aux = {...menuOption}
      aux['enlaces'] = !(existsFavDescendent)? null : components
      return aux;
    } else {
      if(esFav && fatherExistsFavDescendent){fatherExistsFavDescendent(esFav);}
      return !(esFav)  ? null : {...menuOption};
    }
};


export const ListaProductos = ({productos, cia, favs}: ListaProductosProps) => {
    const clases = useStyles();
    const { user } = React.useContext(PortalContext);
    const [menuReducido,setMenuReducido] = React.useState<boolean>(esGestiona()?false:true);
    const [showCompleteVersion,setShowCompleteVersion] = React.useState<boolean>(esGestiona()? true:false);

    if(!esGestiona()){
        const options2 = { focusThrottleInterval: 1000 * 3600 * 4, revalidateOnMount: true, revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false, dedupingInterval: 1000 * 3600 * 4 };
        const { data:dataReducido } = useSWR(["menureducido", user?.id], () => api.post("/be/menureducido", { Entrada: {} }), options2);
      
        React.useEffect(() => {
            console.log('actualizado menu Reducido:', dataReducido?.Salida.MenuReducido)
              if(dataReducido && dataReducido.Salida && dataReducido.Salida.MenuReducido != undefined){
                setMenuReducido(dataReducido?.Salida.MenuReducido);
                setShowCompleteVersion(!dataReducido?.Salida.MenuReducido) ;
              }
          }, [dataReducido]);
    }


    if( ciaShowGroupedProducts.find( item => item === cia ) === undefined ){
        return (<div>
            <React.Fragment>
                <h3>Productos</h3>
                { menuReducido &&
                        <Card
                        className={clases.cardContainer}
                        elevation={0}
                        key={'botonTemporal'}
                        >
                            {showCompleteVersion && <div className={clases.itemMenuReducidoyCompletoContainer} >
                            <span className={clases.itemMenuReducidoyCompleto} onClick={()=>{setShowCompleteVersion(!showCompleteVersion)}} > {"Ver menos opciones de menu" }
                                <IconArriba className={clases.itemIcon}/>
                            </span>
                            </div>}
                            {!showCompleteVersion && <div  className={clases.itemMenuReducidoyCompletoContainer}>
                            <span className={clases.itemMenuReducidoyCompleto} onClick={()=>{setShowCompleteVersion(!showCompleteVersion)}} > {"Ver más opciones de menu" }
                                <IconAbajo className={clases.itemIcon}/>
                            </span>
                            </div>}
                        </Card>
                    }
                <div className={clases.lista}>
                    
                    {productos && productos.map((producto: any, index:number) =>{
                        let hasFavDescendent = false;
                        let prodaux =  (!showCompleteVersion && favs) ? getProductosReducido(producto, favs,(childFav:any)=>{ hasFavDescendent = hasFavDescendent || childFav}): producto
                        return (showCompleteVersion && prodaux)  || (!showCompleteVersion && hasFavDescendent)? <Producto  key ={index} producto={prodaux} favs={favs}/>: null
                    }
                    )}
                </div>
            </React.Fragment>
            </div>
        );
    }
    
    let productosAgrupados: { [column:number]: { [key:string]: { items: any[], order:number } } } = {};

    let config = {};
    switch(cia){
        case "SBI":
            config = relationSBICategory;
            break;
        case "SPU":
            config = relationSPUCategory;
            break;
        default:
            break;
    }

    productos && productos.forEach( (i: any) => {
        let conf = config[i.categoria];
        if (conf){
            let { column, group, order } = conf;
            if(productosAgrupados[column] === undefined) productosAgrupados[column] = {};
            if(productosAgrupados[column][group]){
                productosAgrupados[column][group].items.push(i);
            }else {
                productosAgrupados[column][group] = {
                    order: order,
                    items: [i]
                };
            }
        }
    });

    return (
        <React.Fragment>
            <h3>Productos</h3>
            <ProductosAgrupados productos={productosAgrupados} cia={cia} favs={favs}/>
        </React.Fragment>
    );
};